'use strict';

angular.module('DoohApps').directive('fileread', ['DialogHandler', 'UploadFileStorage', function (DialogHandler, UploadFileStorage) {
    return {
        restrict: 'EA',
        scope: {
            object: '=object',
            onChange: '&',
            maxVideoSize: '@',
            maxImgSize: '@',
            maxFiles: '='
        },
        link: function (scope, element, attributes) {
            if (typeof scope.maxVideoSize == 'undefined')
                scope.maxVideoSize = 2147483648; //2GB
            if (typeof scope.maxImgSize == 'undefined')
                scope.maxImgSize = 20971520; //20MB
            element.bind('change', function (changeEvent) {
                scope.object.HasFile = false;

                if (changeEvent.target.files.length > 0) {
                    var filesSliced = Array.prototype.slice.call(changeEvent.target.files, 0, scope.maxFiles);
                    UploadFileStorage.SetFiles(filesSliced, scope.maxVideoSize, scope.maxImgSize);
                }

                if (UploadFileStorage.HasFiles()) {
                    scope.object.HasFile = true;
                    var files = UploadFileStorage.GetFiles();

                    scope.object.Files = [];
                    for (var i = 0; i < files.length; i++) {
                        var fileType = files[i].type.split('/')[0];
                        void 0;
                        scope.$apply(function () {

                            var obj = {};
                            obj.FileDuration = '0 Minutes';
                            obj.IsArchived = false;
                            obj.IsPublic = true;
                            obj.LanguageId = 1;
                            obj.MediaAssetID = 0;
                            obj.AssetType = fileType;
                            obj.file = files[i];
                            obj.FileName = files[i].name.substring(0, 254);
                            obj.FileExtension = files[i].name.split('.').pop();
                            obj.VirtualPath = '';
                            obj.uploadLinkRecieved = true;
                            obj.uploadRecieved = true;
                            obj.uploadStarting = false;
                            obj.uploadFinishing = false;
                            obj.Size = files[i].size;
                            obj.AssetTitle = files[i].name.substring(0, 50);

                            scope.object.Files.push(obj);

                        });

                        if (fileType == 'image' && files[i].size < 10000000) {
                            var reader = new FileReader();
                            reader.onload = (function (file) {
                                return function (loadEvent) {
                                    scope.$apply(function () {
                                        file.VirtualPath = loadEvent.target.result;
                                    });
                                }

                            })(scope.object.Files[i]);
                            reader.readAsDataURL(files[i]);
                        }
                    }
                    scope.onChange();
                } else changeEvent.target.value = null;
            });
        }
    }
}]);